/* --- GENERIC VARS --- */
var speed = 300;
	ease  = 'easeInOutQuart';

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW ONLOAD) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).load(function()
{

stickyHeader();                     // Sticky header
accordion(speed, ease);             // Accordion
modalWindow(speed, ease);           // Modal window
responsiveImg();                    // Responsive images
submenu(speed, ease);               // Submenu

// Main navigation active state hack
if(jQuery('body').hasClass('post-type-archive-training-centre'))
	jQuery('.menu-item-43').addClass('current-menu-item');
else if(jQuery('body').hasClass('single-training-centre'))
	jQuery('.menu-item-43').addClass('current-menu-ancestor');
else if(jQuery('body').hasClass('post-type-archive-faq'))
	jQuery('.menu-item-38').addClass('current-menu-item');
else if(jQuery('body').hasClass('single-faq'))
	jQuery('.menu-item-38').addClass('current-menu-ancestor');

// Tables
jQuery('table', '.typography').each(function()
{
	jQuery(this).wrap('<div class="table_wrapper"></div>');
});

}); // End window load

/* ######################################################################################################################## */
/* SCRIPTS (DOCUMENT READY) ############################################################################################### */
/* ######################################################################################################################## */
jQuery(document).ready(function($)
{

// Responsive main navigation
var nav = priorityNav.init(
{
	'mainNavWrapper'             : 'nav#main-navigation',
	'navDropdownLabel'           : 'More',
	'navDropdownBreakpointLabel' : 'Menu',
	'breakPoint'                 : 768
});

// Prevent default anchor action
jQuery('a').on('click', function(e)
{
	if(jQuery(this).attr('href') == '#')
		e.preventDefault();
});

// Cycle
jQuery('.cycle').each(function(index, element)
{
	var classSlide = jQuery(element).attr('data-cycle-slides').substr(4);

	if(jQuery(classSlide, element).length > 1)
	{
		var id = jQuery(element).attr('id');

		jQuery(element).cycle(
		{
			easing : ease,
			pager  : '#' + id + '_pager',
			prev   : '#' + id + '_prev',
			next   : '#' + id + '_next',
			log    : false
		});
	}
});

// Cycle Carousel - Cards (mobile)
jQuery('#carousel-cards-mobile').cycle(
{
	fx     : 'carousel',
	easing : ease,
	slides : 'div.slide',
	timeout : 0,
	pager  : '#carousel-cards-mobile_pager',
	prev   : '#carousel-cards-mobile_prev',
	next   : '#carousel-cards-mobile_next',
	log    : false
});

}); // End document ready

/* ######################################################################################################################## */
/* SCRIPTS (WINDOW RESIZE) ################################################################################################ */
/* ######################################################################################################################## */
jQuery(window).bind('resizeEnd', function()
{

// Responsive images
responsiveImg();

// Main navigation
jQuery('body').removeClass('mobile_navigation_active');
jQuery('.main_navigation').removeClass('is-open');
jQuery('.nav__dropdown-toggle').removeClass('is-open');
jQuery('.menu-item-has-children').removeClass('open');
jQuery('.priority-nav__dropdown').removeClass('show');

});

// resizeEnd
jQuery(window).resize(function()
{
	if(this.resizeTO)
		clearTimeout(this.resizeTO);

	this.resizeTO = setTimeout(function()
	{
		jQuery(this).trigger('resizeEnd');
	}, 100);
});

/* ######################################################################################################################## */
/* FUNCTION (RESPONSIVE IMAGES) ########################################################################################### */
/* ######################################################################################################################## */
function responsiveImg()
{
	return jQuery('.responsiveImg').each(function()
	{
		var jQthis    = jQuery('.responsiveImg'),
			jQthisImg = jQthis.find('img'),
			imgSrc;

		if (window.HTMLPictureElement)
		{
			imgSrc = jQthisImg.prop('currentSrc');
		}
		else
		{
			picturefill(
			{
				reevaluate : true
			});

			imgSrc = jQthisImg.attr('src');
		}

		if(imgSrc)
			jQthis.css('background-image', 'url(' + imgSrc + ')');
	});
}

/* ######################################################################################################################## */
/* FUNCTION (SUBMENU) ##################################################################################################### */
/* ######################################################################################################################## */
function submenu(speed, ease)
{
	jQuery(document).on('click', function(e)
	{
		if(jQuery(e.target).closest('.main_navigation').length === 0)
		{
			jQuery('body').removeClass('mobile_navigation_active');
			jQuery('.main_navigation').removeClass('is-open');
			jQuery('.nav__dropdown-toggle').removeClass('is-open');
			jQuery('.menu-item-has-children').removeClass('open');
			jQuery('.priority-nav__dropdown', '.menu-item-has-children').removeClass('show');
		}
	});

	jQuery('span', '.menu-item-has-children').on('click', function(e)
	{
		e.stopPropagation();

		var jQthis     = jQuery(this);
			thisParent = jQthis.parent();

		thisParent.toggleClass('open');
		thisParent.siblings().removeClass('open');

		if(jQuery(window).width() > 845)
		{
			thisParent.siblings().find('.priority-nav__dropdown').removeClass('show');
			jQthis.next('.priority-nav__dropdown').toggleClass('show');
		}
		else
		{
			thisParent.siblings().find('.priority-nav__dropdown').removeClass('show');
			jQthis.next('.priority-nav__dropdown').toggleClass('show');
		}
	});

	jQuery('.nav__dropdown-wrapper').prepend('<span></span>');

	jQuery('.nav__dropdown-toggle').on('click', function()
	{
		if(jQuery(this).parents('.main_navigation').hasClass('is-empty'))
			jQuery('body').toggleClass('mobile_navigation_active');
	});
}

// Record Clicks
jQuery(document).ready(function() {

	jQuery(this).on('click', '.course-document-link', function() {

		jQuery.ajax({
			type: "POST",
			url: "/wp-admin/admin-ajax.php",

			data: {
				action: 'update_downloads',
				doc_ref : jQuery(this).data('ref'),
				doc_link: jQuery(this).attr('href'),
				doc_title: jQuery(this).data('title'),
				doc_date: jQuery(this).data('date'),
				doc_version: jQuery(this).data('version'),
				course_id: jQuery(this).data('course'),
				user_id: jQuery(this).data('user'),
			},

			success: function(data) {
				console.log(data);
			},

		});


	});
});
